import {WorkflowsContainer} from './components/workflows-container';

export default {
    component: WorkflowsContainer
};
